import { MIN_PRICE, MAX_PRICE } from '../../../../constants/listings'
import { useSelector } from 'react-redux'
import { FormField } from '../../..'
import { FilterSection } from '../FilterSection'
import { defineMessages, useIntl } from 'react-intl'
import { selectFilter } from '../../../../store/selectors/filters'

import styles from '../Filters.module.scss'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.price.heading',
    defaultMessage: 'Price'
  },
  min: {
    id: 'General.minimum',
    defaultMessage: 'Minimum'
  },
  max: {
    id: 'General.maximum',
    defaultMessage: 'Maximum'
  }
})

export const Price = () => {
  const intl = useIntl()
  const filters = useSelector(selectFilter)

  return (
    <FilterSection title={intl.formatMessage(MSG.heading)}>
      <div className={styles.rangeFields}>
        {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        <FormField.Dollars className={styles.rangeField} name={MIN_PRICE} defaultValue={filters[MIN_PRICE] || null}>
          {intl.formatMessage(MSG.min)}
          {/* eslint-disable-next-line */}
          {/* @ts-ignore */}
        </FormField.Dollars>
        <div className={styles.dashMark}>—</div>
        {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        <FormField.Dollars className={styles.rangeField} name={MAX_PRICE} defaultValue={filters[MAX_PRICE] || null}>
          {intl.formatMessage(MSG.max)}
          {/* eslint-disable-next-line */}
          {/* @ts-ignore */}
        </FormField.Dollars>
      </div>
    </FilterSection>
  )
}
